import { AvField, AvForm } from "availity-reactstrap-validation";
import { PropTypes } from "prop-types";
import React, { Component } from "react";
import Select from "react-select";
import {
  Card,
  CardBody,
  Col,
  Collapse,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import styled from "styled-components";
import Applications from "./Applications/Index";
import FileTree from "../../../../components/Common/FileTree";
import classnames from "classnames";

// Group Options
const optionStatus = [
  {
    options: [
      { label: "New", value: 1 },
      { label: "Signing contract", value: 2 },
      { label: "integration", value: 3 },
      { label: "Active", value: 4 },
      { label: "Deffered", value: -1 },
      { label: "On hold", value: -2 },
      { label: "Not active", value: -3 },
    ],
  },
];

const optionSource = [
  {
    options: [
      { label: "Unknown", value: 0 },
      { label: "Website", value: 1 },
      { label: "Linkedin", value: 2 },
      { label: "Email", value: 3 },
      { label: "Facebook messenger", value: 4 },
      { label: "Reference", value: 5 },
      { label: "Ad network", value: 6 },
      { label: "Up Sale", value: 7 },
      { label: "Friend", value: 8 },
    ],
  },
];

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUser: null,
      selectedStatus: null,
      selectedSource: null,
      optionsUsers: [],
      selectedFiles: [],
      client: null,
      col_information: true,
      viewAddApp: false,
      docs: [],
    };
    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleSelectUser = this.handleSelectUser.bind(this);
    this.handleSelectStatus = this.handleSelectStatus.bind(this);
    this.handleSelectSource = this.handleSelectSource.bind(this);
  }

  componentDidMount() {
    // this.handleSelectUser({ label: 'None', value: null })
    this.setState({
      client: this.props.client,
    });
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.users.length !== this.props.users.length) {
      let idManagerSales = this.props.users.findIndex(u => u.value === this.props.client.sales_manager);
      if (idManagerSales >= 0) {
        const { label, value } = this.props.users[idManagerSales];
        this.handleSelectUser({
          label,
          value,
        });
      } else {
        this.handleSelectUser({ label: 'None', value: null })
      }
    }

    if (prevState.client !== this.props.client) {
      this.setState({
        client: this.props.client,
      });
      this.handleSelectSource({
        label: this.props.client.source_label,
        value: this.props.client.source,
      });
      this.handleSelectStatus({
        label: this.props.client.status_label,
        value: this.props.client.status,
      });
    }
    if (this.state.selectedStatus === null) {
      this.handleSelectSource({
        label: this.state.client.source_label,
        value: this.state.client.source,
      });
      this.handleSelectStatus({
        label: this.state.client.status_label,
        value: this.state.client.status,
      });
    }
  }

  handleCollapse() {
    this.setState({
      col_information: !this.state.col_information,
    });
  }

  handleSelectUser = selectedUser => {
    this.setState({ selectedUser });
  };

  handleSelectStatus = selectedStatus => {
    this.setState({ selectedStatus });
  };

  handleSelectSource = selectedSource => {
    this.setState({ selectedSource });
  };

  toggleViewAddApp = () => {
    this.setState(prevState => ({
      viewAddApp: !prevState.viewAddApp,
    }));
  };

  handleChangeDocs = data => {
    this.setState({ docs: data });
  };

  render() {
    const { selectedUser, selectedStatus, selectedSource, client } = this.state;

    const onSubmitForm = (e, errors, params) => {
      if (errors?.length === 0) {
        let data = {
          status: this.state.selectedStatus.value,
          source: this.state.selectedSource.value,
          sales_manager: selectedUser.value
        };
        data = {
          ...data,
          ...params,
        };
        this.props.patchClient(this.props.userId, data, this.state.docs);
      }
    };

    const handleClickSave = () => {
      document.getElementById("btn-form-submit").click();
    };

    return (
      <React.Fragment>
        {client && (
          <>
            <div className="accordion" id="accordion">
              <AccordionItem className={classnames("accordion-item")}>
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className={classnames("accordion-button fw-medium", {
                      collapsed: !this.state.col_information,
                    })}
                    type="button"
                    onClick={this.handleCollapse}
                    style={{ cursor: "pointer" }}
                  >
                    Account information
                  </button>
                </h2>

                <Collapse
                  isOpen={this.state.col_information}
                  className="accordion-collapse"
                >
                  <AccordionBody className="accordion-body">
                    <Col lg={12}>
                      <Card>
                        <CardBody>
                          <AvForm
                            className="needs-validation"
                            onSubmit={onSubmitForm}
                          >
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Status</Label>
                                  <Select
                                    value={selectedStatus}
                                    onChange={this.handleSelectStatus}
                                    options={optionStatus}
                                    classNamePrefix="select2-selection"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Source</Label>
                                  <Select
                                    value={selectedSource}
                                    onChange={this.handleSelectSource}
                                    options={optionSource}
                                    classNamePrefix="select2-selection"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Legal Name</Label>
                                  <AvField
                                    value={client.legal_name}
                                    name="legal_name"
                                    placeholder="Legal name"
                                    type="text"
                                    errorMessage="Enter Legal Name"
                                    className="form-control"
                                    disabled={!this.props.permissions["is_admin"]}
                                    validate={{
                                      required: { value: true },
                                      minLength: {
                                        value: 3,
                                        errorMessage: "Min 3 chars.",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Client Name</Label>
                                  <AvField
                                    value={client.real_name}
                                    name="real_name"
                                    placeholder="Client name"
                                    type="text"
                                    errorMessage="Enter Client Name"
                                    className="form-control"
                                    disabled={!this.props.permissions["is_admin"]}
                                    validate={{
                                      required: { value: true },
                                      minLength: {
                                        value: 3,
                                        errorMessage: "Min 3 chars.",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6}>
                                <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                                  <label className="control-label">Email</label>
                                  <AvField
                                    name="email"
                                    value={client.email}
                                    type="email"
                                    className="form-control"
                                    validate={{
                                      required: { value: true, email: true },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Client desc</Label>
                                  <AvField
                                    value={client.description}
                                    name="description"
                                    placeholder="Client desc..."
                                    type="text"
                                    className="form-control"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Comment</Label>
                                  <AvField
                                    value={
                                      client.comment === null
                                        ? ""
                                        : client.comment
                                    }
                                    name="comment"
                                    placeholder="Comment..."
                                    type="text"
                                    className="form-control"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>

                                <FormGroup className="mb-3">
                                  <Label>Sales manager</Label>
                                  <Select
                                    value={selectedUser}
                                    onChange={this.handleSelectUser}
                                    options={[{ options: [{ label: 'None', value: null }, ...this.props.users] }]}
                                    classNamePrefix="select2-selection"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <div style={{ float: "right" }} className="d-none">
                              <button
                                type="submit"
                                className="btn btn-primary w-md"
                                id="btn-form-submit"
                              >
                                Save changes
                              </button>
                            </div>
                          </AvForm>
                        </CardBody>
                      </Card>
                    </Col>
                  </AccordionBody>
                </Collapse>
              </AccordionItem>
            </div>
            {this.props.apps &&
              this.props.permissions["view_clientapplicationmodel"] && (
                <Card>
                  <CardBody>
                    <Applications
                      getAppsById={this.props.getAppsById}
                      apps={this.props.apps}
                      apps_loading={this.props.apps_loading}
                      history={this.props.history}
                      AddAppToggle={this.toggleViewAddApp}
                      deleteApp={this.props.deleteApp}
                      permissions={this.props.permissions}
                      tracking_platforms={this.props.tracking_platforms}
                      patchAppStatus={this.props.patchAppStatus}
                      patchApp={this.props.patchApp}
                      setApp={this.props.setApp}
                      setAppDataNull={this.props.setAppDataNull}
                      addAppById={this.props.addAppById}
                    />
                  </CardBody>
                </Card>
              )}
            <Card>
              <CardBody>
                <Row>
                  <h4 style={{ marginTop: "6px" }}>Documents</h4>
                  <FileTree
                    onChange={this.handleChangeDocs}
                    defaultValue={client?.parsed_docs || []}
                    permissions={this.props.permissions}
                  />
                </Row>
              </CardBody>
            </Card>
            <Card className="bg-transparent shadow-none">
              <div className="text-end">
                {this.props.permissions["change_clientmodel"] && (
                  <button
                    type="submit"
                    onClick={handleClickSave}
                    className="btn btn-primary"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Card>
            {/*<Card>*/}
            {/*  <CardBody>*/}
            {/*    <Row>*/}
            {/*      <h4 className="card-title">Documents</h4>*/}
            {/*      <FileTree*/}
            {/*        onChange={this.handleChangeDocs}*/}
            {/*        defaultValue={this.props.client.documents_info}*/}
            {/*      />*/}
            {/*    </Row>*/}
            {/*  </CardBody>*/}
            {/*</Card>*/}
          </>
        )}
      </React.Fragment>
    );
  }
}

const AccordionItem = styled.div`
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0) !important;

  &.accordion-item__is-close {
    background-color: red !important;
  }

  label {
    //color: red !important;
    color: #74788d !important;
  }
`;

const AccordionBody = styled.div`
  padding: 0 !important;
`;

Settings.propTypes = {
  client: PropTypes.any.isRequired,
  apps: PropTypes.any,
  apps_loading: PropTypes.bool.isRequired,
  patchClient: PropTypes.func.isRequired,
  userId: PropTypes.string,
  history: PropTypes.any.isRequired,
  deleteApp: PropTypes.func.isRequired,
  patchAppStatus: PropTypes.func,
  permissions: PropTypes.any,
  tracking_platforms: PropTypes.any,
  patchApp: PropTypes.func,
  setApp: PropTypes.func,
  setAppDataNull: PropTypes.func,
  addAppById: PropTypes.func.isRequired,
  users: PropTypes.any,
  getAppsById: PropTypes.func.isRequired,
};

export default Settings;